
//ToDo by reda :: Ajouter code postal dans la base de donnee
import './CompteClient.scss';

//import AddIcon from '@mui/icons-material/Add';
//import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
//import Checkbox from '@mui/material/Checkbox';
import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
// import useRole from '../../../hooks/useRole';
// import useRole from '../../../hooks/useRole';
import useWindowSize from '../../../hooks/useWindowSize';
import { SideBarNavigationFicheExpert } from '../../../Styles/componentStyles';
import NewCompany from '../../Client/CompleterProfile/Step3_companyData/NewCompany';
import SideBar from './SideBarGestionClient';

function DonnePersoById() {
    const {pathname} = useLocation();
    const currentPath = pathname.split('/').pop();
    // const role=useRole();
    const {device}=useWindowSize();
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();
    // eslint-disable-next-line no-unused-vars
    const [dataClient, setdataClient] = useState({});
    const [nomEntreprise,setNomEntreprise]=useState('');
    const { i18n } = useTranslation();

    let param = useParams();

    useEffect(() => {
        getClientbyId();
    }, []);

    const getClientbyId = async () => {
        let endpoint = pathname.includes('gestionEsn') ? '/users/getEsnById/':'/users/getClientById/';
        try {
            const response = await axiosPrivate.get(endpoint+(param.ClientId ?? param.EsnId));
            setdataClient(response.data);
            setNomEntreprise(response?.data?.profileEntreprise?.nom);
            console.log('dataClient',response?.data?.profileEntreprise?.nom);
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignItems: 'flex-start',alignSelf:'stretch',gap:'24px'}}>
                <div className='frame5Profile'>{location?.pathname?.includes('gestionEsn')  ? i18n.t('Gestion des Esn'):i18n.t('Gestion des Clients')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{nomEntreprise} </span> </div>
                <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',alignSelf:'stretch',gap:'24px'}}>
                    <SideBar/>
                    <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:device=='desktop'?'85%':'100%',minWidth:device=='desktop'?'500px':'200px',alignItems: 'center',gap:'24px'}}>
                        <div
                            className='frame6CompteExpert'
                            style={{flexDirection:'row',width:'100%',flexWrap:'wrap'}}
                        >
                            <div
                                className='frame4CompteClient'
                                style={
                                    currentPath == 'CompteClient' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p
                                    style={
                                        currentPath == 'CompteClient'  ? SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={()=>{
                                        if(currentPath == 'CompteClient')
                                            navigate('.');
                                        else
                                            navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/DonneeGeneral', { replace: true });
                                    }}
                                >{i18n.t('Données Générales')}</p>
                            </div>
                            <div
                                className='frame5CompteClient'
                                style={
                                    currentPath == 'DonneeFacturation' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p
                                    style={
                                        currentPath == 'DonneeFacturation' ? SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={()=>{
                                        navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/DonneeFacturation', { replace: true });
                                    }}
                                >{i18n.t('Données Facturation')}</p>
                            </div>
                            <div
                                className='frame5CompteClient'
                                style={
                                    currentPath == 'PrestationComplementaire' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p
                                    style={
                                        currentPath == 'PrestationComplementaire' ?
                                            SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={()=>{
                                        navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/PrestationComplementaire', { replace: true });
                                    }}
                                >{i18n.t('Prestation Complémentaire')}</p>
                            </div>
                        </div>
                        {/* - 'adminEsn' est utilisé pour la gestion des (ESN)
                            - 'adminClient' est utilisé pour la gestion des clients
                            - {role=='esn' ? 'adminEsn':'adminClient'}*/}
                        <NewCompany action={'admin'}/>
                    </div>
                </div>
            </div>
        </>
    );
}
export default DonnePersoById;